import { useAppSelector } from "@/config/store";
import CourseQuizRow from "@/pages/courses/components/CourseQuizRow";
import DeleteCourseQuiz from "@/pages/courses/components/DeleteCourseQuiz";
import EditCourseQuiz from "@/pages/courses/components/EditCourseQuiz";
import { Card, List } from "@/components/ui";
import { IEdoCourseQuiz } from "@/shared/model/edo-course-quiz.model";
import { IEdoCourse } from "@/shared/model/edo-course.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import axios from "axios";
import { useEffect, useState } from "react";
import { translate } from "react-jhipster";
import { useNavigate } from "react-router-dom";

const CourseQuizzes = () => {
  const navigate = useNavigate();
  const { entity: course } = useAppSelector<EntityState<IEdoCourse>>(
    (state) => state.edoCourse
  );
  const { updateSuccess } = useAppSelector<EntityState<IEdoCourseQuiz>>(
    (state) => state.edoCourseQuiz
  );
  const [quizzes, setQuizzes] = useState<IEdoCourseQuiz[]>([]);
  const [deleteQuizDialog, setDeleteQuizDialog] = useState<{
    open: boolean;
    entity: IEdoCourseQuiz;
  }>({ open: false, entity: null });
  const [editQuizDialog, setEditQuizDialog] = useState<{
    open: boolean;
    entity: IEdoCourseQuiz;
  }>({ open: false, entity: null });

  const getCourseQuizzes = async () => {
    const response = await axios.get<{
      data: IEdoCourseQuiz[];
    }>(`/courses/${course.id}/course-quizzes`, {
      params: { sortBy: "createdAt,DESC" },
    });
    setQuizzes(response.data.data);
  };

  useEffect(() => {
    if (course.id) {
      getCourseQuizzes();
    }
  }, [course.id]);

  const handleOpenQuiz = (quiz: IEdoCourseQuiz) => {
    navigate(`/courses/${course.id}/quizzes/${quiz.id}/start`);
  };

  useEffect(() => {
    if (updateSuccess) {
      getCourseQuizzes();
    }
  }, [updateSuccess]);

  return (
    <>
      <Card className="surface grid h-full grid-rows-[min-content_auto_min-content] overflow-hidden rounded-3xl p-0">
        <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/50 dark:border-[var(--color-mockup-border)] dark:bg-[var(--color-surface-secondary)]/30">
          <div className="flex flex-wrap items-center justify-between gap-3 p-4">
            <h2 className="font-heading text-heading-3 font-bold text-[var(--color-mockup-text)]">
              {translate("edocendoApp.edoCourseQuiz.home.title")}
            </h2>
          </div>
        </div>
        {quizzes && quizzes.length > 0 ? (
          <List className="divide-y">
            {quizzes.map((quiz, i) => (
              <CourseQuizRow
                key={quiz.id}
                courseQuiz={quiz}
                onDelete={() => setDeleteQuizDialog({ open: true, entity: quiz })}
                onEdit={() => setEditQuizDialog({ open: true, entity: quiz })}
                onOpen={() => handleOpenQuiz(quiz)}
              />
            ))}
          </List>
        ) : (
          <div className="p-4 text-center">
            <p className="text-body text-[var(--color-mockup-text-mid)]">
              {translate("edocendoApp.edoCourseQuiz.home.notFound")}
            </p>
          </div>
        )}
      </Card>
      <EditCourseQuiz
        open={editQuizDialog.open}
        onClose={() => setEditQuizDialog({ open: false, entity: null })}
        courseQuiz={editQuizDialog.entity}
      />
      <DeleteCourseQuiz
        open={deleteQuizDialog.open}
        courseQuiz={deleteQuizDialog.entity}
        onClose={() => setDeleteQuizDialog({ open: false, entity: null })}
      />
    </>
  );
};

export default CourseQuizzes;
